/** @returns Throttled function that can be called at most once in given waitTime(ms). */
const throttle = <F extends (...args: never[]) => void>(
  fn: F,
  waitTime: number
): ((...args: Parameters<F>) => void) => {
  let paused = false;
  let latestArgs: Parameters<F>;

  return function throttled(this: ThisParameterType<F>, ...args) {
    latestArgs = args;

    if (paused) return;

    paused = true;

    window.setTimeout(() => {
      fn.apply(this, latestArgs);

      paused = false;
    }, waitTime);
  };
};

export default throttle;
